import { createApp, defineAsyncComponent } from 'vue';
import App from './App.vue';
import { router } from  './routes';
import { loggingOptions } from './middleware/logging';
import {
    getDynamicImport, getHashMap, stylesUrl
} from './loader';
import VueLogger from 'vuejs3-logger';

import { LicenseManager } from '@ag-grid-enterprise/core';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import { LoggedInUserStore } from '@agyletime/vue-3-common/src/plugins/loggedInUser';
import { ACLPlugin } from '@agyletime/vue-3-common/src/plugins/acl';
import { FeatureFlowPlugin } from '@agyletime/vue-3-common/src/plugins/featureflow';
import { TranslationsPlugin } from '@agyletime/vue-3-common/src/plugins/translations';
import { Pendo } from '@agyletime/vue-3-common/src/plugins/pendo';
import { BasePathPlugin } from '@agyletime/vue-3-common/src/plugins/basePath';

/* eslint-disable-next-line max-len */
LicenseManager.setLicenseKey('CompanyName=Agyle Time,LicensedApplication=Agyle Time,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=12,LicensedProductionInstancesCount=1,AssetReference=AG-027189,ExpiryDate=28_May_2023_[v2]_MTY4NTIyODQwMDAwMA==adf5725b8da6512ae5a848d6fdf5c481');

const app = createApp(App);

app.use(BasePathPlugin);
app.component('NavBar', defineAsyncComponent(async () => {
    // TODO: Dev to get it from node_modules, non dev get it from CDN.
    const { NavBar } = await getDynamicImport('vue-3-common.es.js');
    return NavBar;
}));

app.component('FilterBar', defineAsyncComponent(async () => {
    // TODO: Dev to get it from node_modules, non dev get it from CDN.
    const { FilterBar } = await getDynamicImport('vue-3-common.es.js');
    return FilterBar;
}));

app.component(
    'SidebarComponent',
    defineAsyncComponent(async () => {
    // TODO: Dev to get it from node_modules, non dev get it from CDN.
        const { SidebarComponent } = await getDynamicImport('vue-3-common.es.js');
        return SidebarComponent;
    })
);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
app.use(VueLogger, loggingOptions as any);
app.use(router);
app.use(LoggedInUserStore);
app.use(FeatureFlowPlugin);
app.use(ACLPlugin);
app.use(TranslationsPlugin({}));
app.use(Pendo(import.meta.env.VITE_PENDO_API_KEY));
app.use(async () => {
    // Import the built css for the cdn components
    const hashmap = await getHashMap();
    const stylesheet = document.createElement('link');
    stylesheet.setAttribute('rel', 'stylesheet');
    stylesheet.setAttribute('type', 'text/css');
    stylesheet.setAttribute('href', `${stylesUrl}${hashmap['style.css']}`);
    document.head.appendChild(stylesheet);
});

app.mount('#app');
